import {post} from '@/utils/request';
import {erpserver,oaserver,erpplatserver} from '@/utils/baseUrl';

//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}
//
export async function khtype(params) {
    return post(erpserver+'/currency/khtype', params, true);
}
//
export async function list(params) {
    return post(erpserver+'/payApply/list', params, true);
}
//暂用回头删
export async function list1(params) {
    return post(erpserver+'/purchaseinvoice/list', params, true);
}
//付款类型
export async function fktype(params) {
    return post(erpserver+'/payApply/fktype', params, true);
}
//查询开票方（客户
export async function getkhlist(params) {
    //return post(erpserver+'/currency/getkhlist', params, true);
    return post(erpserver+'/currency/getkhlist', params, true);
}
// 获取申购请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取申购部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    //return post(erpserver+'/purchaseinvoice/getgslist', params, true);
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//orderlist
export async function fkmxlist(params) {
    return post(erpserver+'/payApply/fkmxlist', params, true);
}
export async function fkmxDetail(params) {
    return post(erpserver+'/payApply/fkmxDetail', params, true);
}
//付款申请详情
export async function detail(params) {
    return post(erpserver+'/payApply/detail', params, true);
}
//作废
export async function cancel(params) {
    return post(erpserver+'/payApply/cancel', params, true);
}
//baocun
export async function save(params) {
    return post(erpserver+'/payApply/save', params, true);
}
//
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//bank
export async function getbanklist(params) {
    return post(erpserver+'/currency/getbanklist', params, true);
}
//审批接口
export async function flowsub(params) {
    return post(oaserver+"/flow/flowSub", params, true)
};


